module.exports = __webpack_public_path__ + "static/larnie-boquiren-gilchrist-871a5b4f1ea87a58c11902ffb0c69a3c.jpg";